export const LANG_CHANGE = 'LANG_CHANGE';
export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';